import { render, staticRenderFns } from "./RecordDialog4.vue?vue&type=template&id=08476743&scoped=true&"
import script from "./RecordDialog4.vue?vue&type=script&lang=js&"
export * from "./RecordDialog4.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog4.vue?vue&type=style&index=0&id=08476743&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08476743",
  null
  
)

export default component.exports